module.exports = require("vscode-jsonrpc");